import React from "react";
import { Search } from "lucide-react";
import { displayStatusOf, STATUS_META } from "./workflowMeta";

const DOT = {
  teacher_draft: "bg-slate-300",
  changes_requested: "bg-rose-500",
  hod_review: "bg-amber-500",
  admin_review: "bg-blue-500",
  approved: "bg-emerald-500",
};

/** Class picker rail: one dense row per class, status as a dot + label. */
export default function ClassList({ rows, plans, selectedUid, onSelect, query, onQuery, extra }) {
  return (
    <nav aria-label="Classes" className="flex min-h-0 flex-col rounded-xl border border-slate-200 bg-white">
      <div className="border-b border-slate-200 p-2.5">
        <div className="relative">
          <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
          <input
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            placeholder="Find a class…"
            aria-label="Find a class"
            className="w-full rounded-lg border border-slate-300 py-2 pl-8 pr-2 text-[13px] focus:border-[#1565c0] focus:outline-none focus:ring-2 focus:ring-[#1565c0]/15"
          />
        </div>
        {extra}
      </div>
      <ul className="m-0 max-h-[70vh] min-h-0 list-none overflow-y-auto p-1.5">
        {rows.length === 0 && <li className="px-3 py-6 text-center text-[13px] text-slate-500">No classes found.</li>}
        {rows.map((r) => {
          const plan = plans[r.uid];
          const status = displayStatusOf(plan);
          const active = r.uid === selectedUid;
          let chapters = 0;
          (plan?.terms || []).forEach((t) => t.units.forEach((u) => { chapters += u.chapters.length; }));
          return (
            <li key={r.uid}>
              <button
                type="button"
                onClick={() => onSelect(r.uid)}
                aria-current={active ? "true" : undefined}
                className={`flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left ${active ? "bg-[#eef5ff]" : "hover:bg-slate-50"}`}
              >
                <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${DOT[status] || DOT.teacher_draft}`} />
                <span className="min-w-0 flex-1">
                  <span className={`block truncate text-[13px] ${active ? "font-semibold text-[#1565c0]" : "font-medium text-slate-800"}`}>
                    {r.grade}-{r.section} · {r.subject}
                  </span>
                  <span className="block truncate text-[11px] text-slate-500">
                    {STATUS_META[status]?.label || "Draft"}
                    {chapters ? ` · ${chapters} chapter${chapters === 1 ? "" : "s"}` : " · not started"}
                    {r.teacher_name ? ` · ${r.teacher_name}` : ""}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
